import styled from '@emotion/styled';
import { Typography, colors, Stack } from '@ui-components/neo.tax';
import { ReactComponent as MembersIcon } from '@ui-components/neo.tax/dist/icons/members.svg';

export const StyledLink = styled.a({
  color: colors.primary[600],
});

export const StyledMembersIcon = styled(MembersIcon)({
  color: colors.green[600],
  height: '1.5rem',
  width: '1.5rem',
});

export const StyledTypography = styled(Typography)({
  display: 'block',
  color: colors.gray[500],
  margin: '0.5rem 0',
});

export const MemberTableContainer = styled(Stack)({ width: 460 });
